import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import model from './model';
import NavigationButtons from './NavigationButtons';
import moment from 'moment/moment';

import constants from 'src/constants';
import { SelectField, TextField } from 'src/components/basic';
import { rangeToSelectList } from 'src/helpers';
import { FormRow } from 'components/Form';

export default class QualificationsStep extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const { invalid, loading, error, errorMessage } = model.getApiState('updateQualifications');
    const { handleChange, handleBlur } = model;
    return (
      <>
        <div
          className='mc-modal-body'
          style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
        >
          {!!error && <p className='mc-error'>{errorMessage}</p>}
          <div className='mc-form mc-flex-col-20'>
            <FormRow>
              <SelectField
                template={6}
                isClearable={false}
                label={'Doctor type'}
                description='Choose your role: Specialist (experienced doctor) or Resident (training doctor).'
                name={'doctorType'}
                value={model.input('doctorType')}
                options={constants.general.doctor_types}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <SelectField
                template={6}
                isClearable={false}
                label={'Year of starting'}
                name={'yearOfStarting'}
                value={model.input('yearOfStarting')}
                options={rangeToSelectList(1900, moment().year(), true)}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <TextField
                template={6}
                label={'Institution'}
                name={'institution'}
                value={model.input('institution')}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={invalid}
              />
            </FormRow>
          </div>
        </div>
        <NavigationButtons
          prev={this.props.prev}
          hide={this.props.close}
          next={() => model.saveQualifications((err) => !err && this.props.next())}
          loading={loading}
        />
      </>
    );
  }
}
